<template>
    <div class="sidebar-kpi">
        <div class="sidebar-kpi__label">{{ label }}</div>
        <div class="sidebar-kpi__value">{{ value }}</div>
    </div>
</template>

<script setup>
defineProps({
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
});
</script>

<style scoped>
.sidebar-kpi {
    padding: 0.5rem 0;
}

.sidebar-kpi__label {
    font-size: 0.75rem;
    color: var(--cui-text-muted);
    font-weight: 600;
}

.sidebar-kpi__value {
    font-size: 1.25rem;
    font-weight: 700;
}
</style>
